<template>
  <div class="border product-card-3-1 p-1 rounded">
    <m-product-offer1 :offer-status="offerStatus" :offer-type="offerType" class="position-absolute" :product="product"/>
    <m-card3 :alt="product.name" :image="product.thumbnail">

      <m-a :href="{ name: 'Product', params: { name: product.raw_link } }">
        <h6 class="product-card-310-text">{{ contentSlicer(product.name, 50) }}</h6>
      </m-a>

      <div class="" v-if="showKeywords">
        <span class="badge product-card-310-keyword m-1" v-for="item in product.keywords">{{ item.keyword }}</span>
      </div>

      <div class="" v-for="category in product.category">
        <span class="btn btn-sm product-card-3-1-categories-badge m-1 btn-primary rounded-pill">{{
            category.name
          }}</span>
      </div>


      <div class="">

        <div v-for="productFeature in productTableFeature(product)" class="d-inline-block">
          <template v-if="productFeature.feature != null">
            <template v-if="productFeature.feature.type == 'date'">
              <span class="m-1 product-card-3-1-product-feature  text-dark d-inline-block rounded-pill">
          {{ productFeatureName(product, productFeature.id) }}: {{
                  dateConverter(productFeatureValue(product, productFeature.id), '/', false)
                }}
              </span>
            </template>
            <template v-else>
              <span class="m-1 product-card-3-1-product-feature  text-dark d-inline-block rounded-pill">
          {{ productFeatureName(product, productFeature.id) }}: {{ productFeatureValue(product, productFeature.id) }}
              </span>
            </template>
          </template>
        </div>

      </div>
    </m-card3>
  </div>

</template>

<script>
import mCard3 from "../../Cards/Card3";
import mProductCardQuantityManager1 from "../../Product/QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice100 from "../../Product/ProductPrice100";
import mA from '../../Tags/A'
import mProductOffer1 from "../../Product/ProductOffer/ProductOffer1";
import {OfferProps} from '../ProductOffer/ProductOfferProps'
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {mapGetters} from "vuex";
import {
  productFeatureName,
  productFeatureValue,
  productTableFeature
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "ProductCard3_1",
  components: {mCard3, mProductCardQuantityManager1, mA, mProductPrice100, mProductOffer1},
  props: {
    product: {},
    productCardLink: {
      default: '_self',
    },
    showKeywords: {
      type: Boolean,
      default: false
    },
    OfferProps
  },
  computed: {
    ...mapGetters({
      isAdmin: 'User/isAdmin',
      isUserStore: 'User/isUserStore',
    }),
    publishStatus() {
      return this.product.status == 0 ? false : true
    },
    publishStatusText() {
      if (this.publishStatus) { // published true
        return this.$t('filter.product_status.publish')
      }
      return this.$t('filter.product_status.draft')
    },
  },
  methods: {
    dateConverter,
    productFeatureValue,
    productFeatureName,
    productTableFeature,
    ...shoppingCartFunctions,
  }
}
</script>

<style scoped>
.product-card-3-1-categories-badge {
  font-size: 10px;
}

.product-card-3-1-publish-status-draft {
  background: var(--danger);
  color: white;
}

.product-card-3-1-publish-status-success {
  background: var(--success);
  color: white;
}

.product-card-3-1-product-feature {
  padding: 0 7px;
  font-size: 13px;
  background: var(--secondary);
}

.product-card-3-1 :deep(.card) {
  border: none !important;
}
</style>
